import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

const STORAGE_KEY = "cg-color-scheme";

@Injectable({ providedIn: "root" })
export class ThemeService {
    private schemeSubject = new BehaviorSubject<"light" | "dark">(this.getStoredScheme());
    scheme$ = this.schemeSubject.asObservable();

    constructor() {
        this.apply(this.schemeSubject.value);
    }

    get scheme(): "light" | "dark" {
        return this.schemeSubject.value;
    }

    toggle() {
        this.setScheme(this.scheme === "dark" ? "light" : "dark");
    }

    setScheme(scheme: "light" | "dark") {
        this.apply(scheme);
        localStorage.setItem(STORAGE_KEY, scheme);
        this.schemeSubject.next(scheme);
    }

    private apply(scheme: "light" | "dark") {
        document.documentElement.classList.toggle("dark", scheme === "dark");
    }

    private getStoredScheme(): "light" | "dark" {
        return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
    }
}
